import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableAdditionalColumns } from '@fi-shared/fi-wrapper-table/fi-wrapper-table-additional-columns';

@Component({
    selector: 'fi-checklist2-answer-comments',
    template: `
        <ng-container matColumnDef="Comments">
          <mat-header-cell *matHeaderCellDef>
            <fi-wrapper-table-span-cell [value]="'common.comments' | fiAppText" />
          </mat-header-cell>
        
          <mat-cell *matCellDef="let item" class="column-show-mobile">
            <fi-wrapper-table-rollup-content-cell>
              @for (comment of item.Comments; track comment) {
                <span>{{ comment.Content }}</span>
              }
            </fi-wrapper-table-rollup-content-cell>
          </mat-cell>
        </ng-container>
        `,
    styleUrls: ['./fi-checklist2-answer-comments.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-answer-value' },
    providers: [{ provide: FiWrapperTableAdditionalColumns, useExisting: FiChecklist2AnswerCommentsComponent }],
    standalone: false,
})
export class FiChecklist2AnswerCommentsComponent extends FiWrapperTableAdditionalColumns {}
